/* eslint-disable react/require-default-props */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable react/jsx-props-no-spreading */
import React from "react";
import clsx from "clsx";
import { CheckMark, Input, CheckboxLabel } from "./styles";

const LABEL_SIDE_OPTIONS = {
	left: "left",
	right: "right",
};

type Props = {
	[x: string]: any;
	label: any;
	labelSide?: string;
	disabled?: boolean;
	checked: any;
};

const CheckboxInput: React.FC<Props> = ({
	label,
	labelSide = LABEL_SIDE_OPTIONS.right,
	checked,
	onClick,
	isRadioButton = true,
	disabled = false,
	...props
}) => (
	<CheckboxLabel isSelected={checked} labelSide={labelSide} onClick={onClick}>
		<span
			className={clsx("labelSpan", {
				"!text-[#D1CED4]": disabled,
			})}
		>
			{label}
		</span>
		<Input type="checkbox" disabled={disabled} {...props} />
		<div>
			<CheckMark
				className="checkmark"
				isSelected={checked}
				isRadioButton={isRadioButton}
				disabled={disabled}
			/>
		</div>
	</CheckboxLabel>
);

export default CheckboxInput;

CheckboxInput.defaultProps = {
	labelSide: LABEL_SIDE_OPTIONS.right,
};
